import React, { useContext, FunctionComponent } from 'react'
import {observer} from 'mobx-react'
import {Row} from './Row'
import { TableStoreContext, TableStore } from './TableStore'

const REUSE_DOM_NODES = false

export const Rows: FunctionComponent<{}> = observer(() => {
  const tableStore: TableStore = useContext(TableStoreContext)

  return (
    <>
      {tableStore && tableStore.visibleCells && tableStore.visibleCells.visibleRowIds.map((rowId, visibleIndex) => (
        <Row 
          key={REUSE_DOM_NODES ? visibleIndex : rowId}
          rowId={rowId}
        />
      ))}
    </>
  )
})